import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-[20px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = {
  class: "pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]",
  id: "contactsNavigation"
}
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = { class: "pt-[60px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]" }
const _hoisted_6 = {
  class: "mb-5",
  id: "contactsForm"
}

import contactsNavigation from '@/components/SubNavigations/TheContactsNavigation.vue'
    import useContactStore from '@/utils/useContactStore'
    import contactsForm from '@/components/Contacts/ContactsForm.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsSearch',
  setup(__props) {

    const { selectedContact } = useContactStore()

    selectedContact.value = null

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(contactsNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-2xl font-semibold" }, "Erweiterte Suche", -1)),
          _createVNode(contactsForm)
        ])
      ])
    ])
  ], 64))
}
}

})